import {
  faDownload,
  faEdit,
  faSparkles,
  faThumbtack,
} from "@fortawesome/pro-regular-svg-icons";
import { faGripDotsVertical } from "@fortawesome/pro-solid-svg-icons";

import { EllipsisOptionsDropdown } from "src/base-components/OptionsDropdown/EllipsisOptionsDropdown";
import { extractTitle } from "src/chartSandbox/SandboxedChart";
import { Icon } from "src/design-system/Icon";

// TODO(OPTI-7869): align with / promote to a base card component.
export const DashboardChartCard: React.FC<{
  chartDefinition: Record<string, unknown>;
  title?: string | null;
  onEdit?: () => void;
  onUnpin?: () => void;
  onExport?: () => void;
  onExplore?: () => void;
  exploreDisabled?: boolean | string;
  isEditing?: boolean;
  callout?: React.ReactNode;
  children: React.ReactNode;
}> = ({
  chartDefinition,
  title,
  onEdit,
  onUnpin,
  onExport,
  onExplore,
  exploreDisabled,
  isEditing = false,
  callout,
  children,
}) => (
  <div className="flex h-full flex-col rounded-md border border-gray-200 bg-white">
    <div className="flex items-center justify-between border-gray-200 border-b px-4 py-3">
      <span className="flex items-center gap-x-2 font-inter-semibold-13px text-gray-800">
        {isEditing && (
          <span
            className="dashboard-drag-handle cursor-grab text-gray-500 active:cursor-grabbing"
            data-loc="dashboard-reorder-handle"
          >
            <Icon icon={faGripDotsVertical} size="xs" />
          </span>
        )}
        {title || extractTitle(chartDefinition)}
      </span>
      {!isEditing && (
        <EllipsisOptionsDropdown
          dataLoc="dashboard-pin-options"
          elements={[
            ...(onExplore
              ? [
                  {
                    key: "Explore with Copilot",
                    icon: faSparkles,
                    action: onExplore,
                    disabled: exploreDisabled,
                  },
                ]
              : []),
            ...(onEdit
              ? [{ key: "Rename chart", icon: faEdit, action: onEdit }]
              : []),
            ...(onExport
              ? [{ key: "Export CSV", icon: faDownload, action: onExport }]
              : []),
            ...(onUnpin
              ? [{ key: "Unpin chart", icon: faThumbtack, action: onUnpin }]
              : []),
          ]}
        />
      )}
    </div>
    {callout && <div className="px-4 pt-4">{callout}</div>}
    <div className="min-h-0 flex-1 p-4">{children}</div>
  </div>
);
